import React, { useEffect, useRef } from "react";
import { ActivityReservationInternalModel } from "Services/API/API";
import { formatStringDate } from "Utils/date";
import ActivityCard from "./ActivityCard";

import classes from "./ActivityList.module.scss";
import classNames from "classnames";

interface ActivityDayListProps {
   index: number;
   className?: string;
   activities: ActivityReservationInternalModel[];
   date: string;
   setHeight: (index: number, height: number) => void;
}

const ActivityDayList: React.FC<ActivityDayListProps> = ({
   index,
   className,
   activities,
   date,
   setHeight,
}) => {
   const ref = useRef<HTMLDivElement>(null);

   useEffect(() => {
      if (!ref.current) return;

      const height = ref.current?.getBoundingClientRect().height ?? 0;
      setHeight(index, height);
    }, [setHeight, index]);

   return (
      <div className={className} ref={ref}>
         <div className={classNames(classes.date, { [classes.firstDate]: index == 0 })}>
            {formatStringDate(date, "MMMM D, dddd")}
         </div>
         <div>
            {activities.map((activity) => (
               <ActivityCard
                  key={activity.reservationId}
                  activity={activity}
               />
            ))}
         </div>
      </div>
   );
};

export default ActivityDayList;
